import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  { state: 'dashboard', name: 'dashboard', type: 'link', icon: 'dashboard', priv: 'rd_dashboard', children: [] },
  { state: 'session/collection', type: 'link', name: 'Session Collection', icon: 'payments', priv: 'rd_session', children: [] },
  { state: 'session/central-cash-register', type: 'link', name: 'central_cash_register', icon: 'account_balance_wallet', priv: 'rd_session', children: [] },
  { state: 'account/treasury-management', type: 'link', name: 'Gestion Trésorerie & Dépenses', icon: 'account_balance_wallet', priv: 'rd_session', children: [] },
  { state: 'session', type: 'link', name: 'raportsession', icon: 'update' , priv: 'rd_session', children: []},
];

@Injectable()
export class MenuItemsAccounting {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
